const expense_icon_map = {
  "food expense": "#7f87b2",
  "hotel stay": "#83b2d0",
  stationary: "#95dab6",
  petrol: "#dc8580",
  "bus travel": "#f2e6b1",
  "courier charges": "#7f87b2",
  "train travel": "#7f87b2",
  travel: "#f2e6b1",
  "local conveyance": "#83b2d0",
  "air travel": "#95dab6",
  telecom: "#d9cf9f",
  internet: "#83b2d0",
  brokerage: "skyblue",
  entertainment: "#dc8580",
  electronics: "#d9cf9f",
  others: "#d9e7f0",
  "online shopping": "#d9cf9f",
};
export const nativeMuiIconMap = {
  daily: "calendar_today",
  monthly: "calendar_month",
  electronics: "devices",
  "office supplies": null,
  internet: null,
  mobile: "smartphone",
  "bus travel": "airport_shuttle",
  entertainment: null,
  "air travel": "flight_takeoff",
  "hotel stay": "bed",
  "local conveyance": "wallet_travel",
  brokerage: "currency_rupee",
  "online shopping": "shopping_bag",
  "courier charges": "local_shipping",
  "food expense": "fastfood",
  petrol: "local_gas_station",
  telecom: "smartphone",
  others: "description",
};

export function mapExpenseTypes(expenseTypes, tool) {
  return expenseTypes?.map((exp, index) => {
    return {
      id: index + 4,
      icon: exp.icon,
      bgColor: expense_icon_map[exp.name?.toLowerCase()?.trim()],
      value: exp.name?.trim(),
      label: exp.label.trim() || exp.name.trim(),
      type: "expense",
      name: tool === "invoice-extraction" ? "expenseType" : exp.value,
    };
  });
}

export function getDocsAndFields(tools) {
  let docFields = {};
  let toolDocs = {};
  let allDocs = [];
  let addedDocs = [];

  for (let i = 0; i < tools.length; i++) {
    let docs = tools[i].Children;
    toolDocs[tools[i].name] = docs;
    for (let j = 0; j < docs.length; j++) {
      let doc = docs[j];
      if (!addedDocs.includes(doc.name)) {
        addedDocs.push(doc.name);
        allDocs.push(doc);
      }
      let fields = docs[j].Children;
      if (!docFields[doc.name]) {
        docFields[doc.name] = {
          fields,
          important: doc?.extraInfo?.importantFields,
        };
      }
    }
  }
  return { docFields, toolDocs, allDocs };
}

export function getImpFieldHelper(row, docFields, ind = 0) {
  let fields =
    docFields && docFields[row.type] ? docFields[row.type]?.important : null;
  let field1 = fields && fields[ind] ? fields[ind] : "";
  if (row?.DocHistories?.[0]) {
    let found = row?.DocHistories[0]?.DocData?.find(
      (field) => field.name === field1,
    );
    if (found) return found.label + ": " + found.value;
    else return "";
  } else return "";
}

export function camelToSentenceCase(camelCaseString) {
  // Step 1: Insert a space before any uppercase letter that follows a lowercase letter
  const spacedString = camelCaseString.replace(/([a-z])([A-Z])/g, "$1 $2");

  // Step 2: Capitalize the first letter of the entire string
  const sentenceCaseString =
    spacedString.charAt(0).toUpperCase() + spacedString.slice(1);

  return sentenceCaseString;
}
